import { cn } from "@/lib/utils"

function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      className={cn("bg-neutral-background-100 animate-pulse rounded-s", className)}
      {...props}
    />
  )
}

export { Skeleton }
